import { StatusChangeByComponentView } from "./StatusChangeByComponentView.model";

export class RequestStatusAgencyPolicyViewModel extends StatusChangeByComponentView {
    public File:string;
    
}